import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import useFormHook from '@shared/hooks/useFormHook';

const CreateCalendarModal = ({ onClose, onConfirm, monthName, year }) => {
    const { modalRef } = useFormHook({}, onClose);
    const { t, i18n } = useTranslation();

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm delete-modal" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faCheckCircle} />
                        </div>
                        <h4 className="modal-title">
                            {t('additionalSettings.calendar.table.createCalendar')}
                        </h4>
                        <p className="delete-message">
                            {i18n.language === 'bg' 
                                ? `Няма създаден календар за ${monthName} ${year}. Ще създадете ли?`
                                : `No calendar created for ${monthName} ${year}. Would you like to create one?`
                            }
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-danger" onClick={onConfirm}>
                            {i18n.language === 'bg' ? 'Да' : 'Yes'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {i18n.language === 'bg' ? 'Не' : 'No'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateCalendarModal;

